import r from "../managers/braze-instance.js";
import { logger as E } from "../../shared-lib/index.js";
export function getDeviceId(e) {
  if (!r.rr()) return;
  var t = r.de();
  if (!t) return;
  var i = t.fe().id;
  if ("function" != typeof e) return i;
  E.warn("The callback for getDeviceId is deprecated. You can access its return value directly instead (e.g. `const id = braze.getDeviceId()`)"), e(i);
}